module.exports = __webpack_public_path__ + "media/images/icon-lock-outline-12990892147e2b5b4302f4952ecfc38e.svg";